import { render, staticRenderFns } from "./contributorRegistration.vue?vue&type=template&id=8479f8c0"
import script from "./contributorRegistration.vue?vue&type=script&lang=js"
export * from "./contributorRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports